/* ===========================================================================
   gnpbl-motion.js — motion for the BLOG INDEX only (sections/gnp-blog.liquid).
   Loaded from that section and nowhere else.

   THE ONE RULE THIS FILE EXISTS TO KEEP:
   IF A SCRIPT APPLIES THE START STATE, THE SCRIPT MUST ALSO SKIP IT.
   The About hero shipped a reduced-motion defect for weeks because the start
   state was written INLINE by script and the @media (prefers-reduced-motion)
   block written to cancel it could never win — no stylesheet rule beats an
   inline declaration at any specificity. See CLAUDE.md, "AN INLINE START
   STATE CANNOT BE CANCELLED BY A MEDIA QUERY".

   So here:
     - the start states live in the SECTION'S CSS, gated behind .gnpbl-anim
     - this script adds .gnpbl-anim only when motion is allowed
     - under reduced motion, or with JS off, the class is never added and
       every card and hero word is visible at rest
   Nothing is ever parked off-screen by a reveal that failed to fire, because
   without this script nothing is hidden in the first place.

   VERIFY IT WITH A NULL CONTROL. "All cards visible under reduced motion"
   proves nothing alone — it is also what a probe that cannot see the start
   state returns. Read the same page with reduced motion OFF and confirm the
   translate IS present. The contrast is the result; either half alone is not.

   IT NEVER TOUCHES ARTICLE CONTENT. The only DOM write is wrapping the h1's
   own words in spans for the mask, and h1.textContent is identical before and
   after that wrap (gated). No article body, title, excerpt or tag is read,
   moved or rewritten anywhere in this file.
   =========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.gnpbl-root');
  if (!root) return;

  var reduce = false;
  try {
    reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    reduce = false;
  }

  /* Reduced motion: do nothing at all. No class, so no start state, so
     nothing to undo and nothing that can be left parked. */
  if (reduce) return;

  /* ---- hero word mask -----------------------------------------------------
     Wrap each WORD of the h1 in <span class="gnpbl-w"><span --gnpbl-i=n>.
     Split on whitespace and rejoin with a single space: the h1 is a plain
     text node here (it renders {{ blog.title }}), so textContent before and
     after differ only in collapsible whitespace, which is what the gate
     compares. If the h1 ever contains markup this must be revisited rather
     than trusted — innerHTML would be destroyed by the line below. */
  var h1 = root.querySelector('.gnpbl-hero h1');
  if (h1 && h1.children.length === 0) {
    var words = h1.textContent.trim().split(/\s+/);
    var html = '';
    for (var i = 0; i < words.length; i++) {
      var w = words[i]
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      html += '<span class="gnpbl-w"><span style="--gnpbl-i:' + i + '">' + w + '</span></span>';
      if (i < words.length - 1) html += ' ';
    }
    h1.innerHTML = html;
  }

  /* Add the animation class, then flip to .gnpbl-in on the next two frames so
     the start state is actually painted before the transition begins. One
     frame is not reliably enough. */
  root.classList.add('gnpbl-anim');
  var enter = function () { root.classList.add('gnpbl-in'); };
  requestAnimationFrame(function () { requestAnimationFrame(enter); });

  /* SAME GUARANTEE AS THE CARDS, FOR THE SAME REASON. Once .gnpbl-anim is on
     the root the h1's words are masked at translateY(110%) and the stats and
     search sit at opacity 0 — all of it waiting on .gnpbl-in. requestAnimation
     Frame does not run in a backgrounded tab, so a page opened in a background
     tab has a HEADLINE THAT DOES NOT EXIST until something schedules a frame.
     Observed on the draft: root carried gnpbl-anim with no gnpbl-in, h1 words
     translated 85px, stats and search at opacity 0.
     classList.add is idempotent, so this costs nothing when rAF works. */
  setTimeout(enter, 1200);

  /* ---- cards fade up on entry -------------------------------------------- */
  var cards = root.querySelectorAll('.gnpbl-card');
  if (!cards.length) return;

  var reveal = function (el) {
    el.classList.add('gnpbl-cin');
  };

  if (typeof window.IntersectionObserver === 'function') {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    Array.prototype.forEach.call(cards, function (c) { io.observe(c); });
  } else {
    /* No IntersectionObserver: show everything rather than hide it. */
    Array.prototype.forEach.call(cards, reveal);
  }

  /* FAIL-SAFE — UNCONDITIONAL, AND THAT IS THE WHOLE POINT.
     After 2s, reveal EVERY card that has not revealed, wherever it is on the
     page. No viewport test.

     An earlier version of this only revealed cards whose top was already
     inside the viewport, and it shipped a real defect on the draft: 6 of 11
     cards never revealed, 3 of them sitting 35.7% visible on screen at
     opacity 0. Measured, not theorised. The cause did not matter — a
     backgrounded tab, a coalesced callback, an observer that never armed —
     because the consequence is identical every time and it is the worst one
     available: CONTENT THAT IS SIMPLY NOT THERE, with no error anywhere.

     A REVEAL-ON-SCROLL EFFECT MUST NEVER BE THE ONLY THING BETWEEN A READER
     AND THE TEXT. The observer's job is to decide whether a card ANIMATES.
     Whether a card is VISIBLE is not its business, and after this timeout it
     no longer has a say. The cost of getting it wrong in this direction is a
     card that appears without a fade; the cost in the other direction is an
     article nobody can read. */
  setTimeout(function () {
    Array.prototype.forEach.call(root.querySelectorAll('.gnpbl-card:not(.gnpbl-cin)'), reveal);
  }, 2000);
})();
